import { render, staticRenderFns } from "./CmgOrderConfirmationPickupInfo.vue?vue&type=template&id=24fedc28&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-pickup-info.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-pickup-info.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationPickupInfo.vue?vue&type=style&index=0&id=24fedc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fedc28",
  null
  
)

export default component.exports